module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Fb-Gb-Hc-Ia.86ae2be7.png";